export default __webpack_public_path__ + "static/media/feedback_submittedicon.0440270d.svg";